import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import Helmet from 'react-helmet';
import { ListItem } from 'material-ui/List';
import { DataTable, EmptyState, PageHeader, SelectableList, Spinner } from 'components';
import { getReports } from 'redux/modules/reporting';
import { getSocialAccounts } from 'redux/modules/organization';
import ReportingCharts from './ReportingCharts';
var SummaryReport = (_dec = connect(function (state, props) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    gettingReports: state.reporting.gettingReports,
    reports: state.reporting.reports && state.reporting.reports[orgId] ? state.reporting.reports[orgId] : []
  };
}, {
  getSocialAccounts: getSocialAccounts,
  getReports: getReports
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(SummaryReport, _Component);

  var _super = _createSuper(SummaryReport);

  function SummaryReport() {
    var _this;

    _classCallCheck(this, SummaryReport);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleRowSelection", function (selectedRows) {
      browserHistory.push({
        pathname: "/org/".concat(_this.props.params.organizationId, "/reports/summary/").concat(selectedRows.id)
      });
    });

    return _this;
  }

  _createClass(SummaryReport, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getReports(this.props.organization.id);
    }
    /** *******************************************************************************************
     EVENT HANDLERS
    ********************************************************************************************/

  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var filteredReports = this.props.reports && !!this.props.reports.length ? this.props.reports.filter(function (r) {
        return r.reportType === 'monthly' && !r.isArchived;
      }) : [];
      var reports = filteredReports.map(function (r) {
        r.prettyCreatedAt = moment(r.updatedAt).format('MM/DD/YYYY');
        r.dateRange = "".concat(moment(r.startDate).format('MM/DD/YYYY'), " - ").concat(r.prettyEndAt = moment(r.endDate).format('MM/DD/YYYY'));
        return r;
      });
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 36,
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Reports - Summary Report"
      }), /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Reports",
        secondary: "Social Media Summary"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '0 0 auto',
          minHeight: '100%'
        }
      }, this.props.gettingReports && /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1 1 auto'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), !this.props.gettingReports && /*#__PURE__*/React.createElement(DataTable, {
        noRowClasses: true,
        firstColColored: true,
        headerFields: [{
          name: 'Title',
          key: 'name'
        }, {
          name: 'Date Range',
          key: 'dateRange'
        }, {
          name: 'Created At',
          key: 'prettyCreatedAt'
        }],
        data: reports,
        fixedHeader: true,
        height: 500,
        hideSort: true,
        onRowSelection: this.handleRowSelection,
        style: {
          padding: '8px 24px',
          flex: '1 1 auto'
        }
      })));
    }
  }]);

  return SummaryReport;
}(Component)) || _class);
export default SummaryReport;